import { useState, useEffect } from "react";
import {
    Box,
    Button,
    Grid,
    Card,
    Typography,
    Tabs,
    Tab,
    Dialog,
    DialogContent,
    DialogContentText,
    AppBar,
    Toolbar,
    IconButton,
    CardContent,
} from "@mui/material";
import { toast } from "react-toastify";
import { get_inscriptions, get_parameters, save_inscription } from "./services";
import Scan from "./scan";
import moment from "moment";
import Dashboard from "./dashboard";
import DialogLogin from "./dialog_login";
import { sha256 } from "js-sha256";
import PropTypes from "prop-types";
import { Close } from "@mui/icons-material";

import InscriptionTableau from "./inscription_array";
export default function Admin() {
    const [inscriptions, set_inscriptions] = useState([]);

    async function update_inscriptions() {
        try {
            const { data: inscriptions_found } = await get_inscriptions();
            set_inscriptions(inscriptions_found);
        } catch (e) {
            console.log(e);
            toast.error("Erreur");
        }
    }

    useEffect(() => {
        update_inscriptions();
    }, []);

    const [inscription, set_inscription] = useState(null);
    const [uuid, set_uuid] = useState(null);
    const [is_logged, set_is_logged] = useState(false);

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    document.title = "Admin";

    const check_login = async () => {
        try {
            // set_is_logged(true);
            // return;
            const password = localStorage.getItem("token");
            if (!password) {
                set_is_logged(false);
                return;
            }
            const { data: parameters } = await get_parameters();
            if (parameters[0].password !== sha256(password)) {
                localStorage.removeItem("token");
                set_is_logged(false);
                return;
            }
            set_is_logged(true);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        check_login();
    }, []);

    useEffect(() => {
        async function find_inscription() {
            try {
                const { data: inscriptions_found } = await get_inscriptions({ uuid: uuid });
                if (!inscriptions_found.length) {
                    toast.error("Aucune inscription trouvée !");
                    set_inscription(null);
                    return;
                }
                toast.success(`Inscription trouvée : ${inscriptions_found[0].nom} ${inscriptions_found[0].prenom}`);
                set_inscription(inscriptions_found[0]);
            } catch (e) {
                console.log(e);
                toast.error("Erreur");
            }
        }
        if (!uuid) return;
        find_inscription();
    }, [uuid]);

    const validate_inscription = async (id) => {
        try {
            const res = await save_inscription({ id: id, date_validation: moment().format("YYYY-MM-DDTHH:mm:00") });

            if (res.status < 200 || res.status >= 400) {
                throw new Error("Wrong return code");
            }
            set_inscription(null);
            await update_inscriptions();
        } catch (e) {
            console.log(e);
            toast.error("Erreur dans la mise à jour");
        }
    };

    return is_logged ? (
        <Box>
            <Box>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
                        <Tab label="Scan" {...a11yProps(0)} />
                        <Tab label="Paramètres" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Box>
                        <Grid container spacing={1} align="left">
                            <Grid item md={12} xs={12}>
                                <Scan set_uuid={set_uuid} />
                            </Grid>

                            {inscriptions?.length && (
                                <Grid item md={12} xs={12}>
                                    <InscriptionTableau inscriptions={inscriptions} height={500} update_inscription={validate_inscription} />
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Box sx={{ width: { xs: "125%", md: "100%" }, ml: { xs: -4, md: 0 } }}>
                        <Grid container spacing={1} align="left">
                            <Grid item md={12} xs={12}>
                                <Dashboard update_inscription={validate_inscription} />
                            </Grid>
                        </Grid>
                    </Box>
                </TabPanel>
            </Box>

            <Dialog
                open={inscription}
                fullScreen
                onClose={() => set_inscription(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <AppBar sx={{ position: "relative" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={() => set_inscription(null)} aria-label="close">
                            <Close />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    {inscription && (
                        <DialogContentText id="alert-dialog-description">
                            <Grid container spacing={1} align="left">
                                <Grid item md={12} xs={12}>
                                    <Card sx={{ bgcolor: inscription?.date_validation ? "error.main" : "success.main" }}>
                                        <CardContent>
                                            <Grid item md={12} xs={12}>
                                                <Typography variant="h6" color="text.primary">
                                                    Nom : {inscription.nom} {inscription.prenom}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <Typography variant="h6" color="text.primary">
                                                    Email : {inscription.email}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <Typography variant="h6" color="text.primary">
                                                    Téléphone : {inscription.telephone}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <Typography variant="h6" color="text.primary">
                                                    UUID : {inscription.uuid}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <Typography variant="h6" color="text.primary">
                                                    Date inscription : {moment(inscription?.date_creation).format("ddd DD/MM/YYYY HH:mm")}
                                                </Typography>
                                            </Grid>
                                            {inscription?.date_validation && (
                                                <Grid item md={12} xs={12}>
                                                    <Typography variant="h6" color="text.primary">
                                                        Date validation : {moment(inscription?.date_validation).format("ddd DD/MM/YYYY HH:mm")}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    {inscription?.date_validation ? (
                                        <Button variant="contained" color="error">
                                            Billet déjà utilisé !
                                        </Button>
                                    ) : (
                                        <Button variant="contained" color="success" onClick={() => validate_inscription(inscription?.id)}>
                                            Marquer comme validée
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    ) : (
        <DialogLogin check_login={check_login} />
    );
}
